import { 
	GET_EMPLOYEE_TASKS, 
	GET_EMPLOYEE_TASK,
	CREATE_EMPLOYEE_TASK,
	UPDATE_EMPLOYEE_TASK,
	DESTROY_EMPLOYEE_TASK,
} from "./actions"

export function EmployeeTasksReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_EMPLOYEE_TASKS}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_EMPLOYEE_TASK}_FULFILLED`:
		case `${CREATE_EMPLOYEE_TASK}_FULFILLED`:
		case `${UPDATE_EMPLOYEE_TASK}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_EMPLOYEE_TASK}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { EmployeeTasksReducer } from "modules/employee/tasks/reducer"

// employee_tasks:EmployeeTasksReducer,
